module.exports = __webpack_public_path__ + "search-50dbcab8f9242bb7752f.svg";